import React from 'react';
import { Typography, Box, Link } from 'vindi-ds-components';
import styles from './styles';
import ScaffoldCard from './scaffold_card';

function generateLink(linkInfo, paddingInfo, labelInfo) {
  return (
    <Link href={linkInfo} style={{ padding: paddingInfo }}>
      <Typography variant='caption'>
        {labelInfo}
      </Typography>
    </Link>
  );
}

function CompleteCard({
  successTitle, completedMessage, completedLinkLabel, completedLink,
  isCompleted, successSubtitle, firstStep, secondStep, thirdStep, id,
}) {
  const CardFooter = () => (
    <Typography color='textSecondary' variant='body2'>
      {completedMessage}
      <CardLinks />
    </Typography>
  );

  const CardDescription = ({ color = 'textSecondary', variant = 'body2' }) => (
    <>
      <Typography color={color} variant={variant}>
        {successSubtitle}
      </Typography>
      <Typography color={color} variant={variant}>
        {firstStep}
      </Typography>
      <Typography color={color} variant={variant}>
        {secondStep}
      </Typography>
      <Typography color={color} variant={variant}>
        {thirdStep}
      </Typography>
    </>
  );

  const CurrentDescription = id === 'paymentPage' ? CardFooter : CardDescription;

  const CardLinks = () => (
    <Box
      css={styles.cardLinks}
    >
      {generateLink(completedLink, '0px', completedLinkLabel)}
    </Box>
  );

  return (
    <ScaffoldCard
      css={styles.complete}
      CardFooter={CurrentDescription}
      iconColor='#00AD1D'
      title={successTitle}
      isCompleted={isCompleted}
    />
  );
}

export default CompleteCard;
